<template>
  <div class="docs-area">
    <div class="document">
      <h1 class="page-title">
        {{ $t('policy.h1') }}
      </h1>
      <p class="published">
        {{ $t('policy.updated') }}: 11<sup><small>th</small></sup> of April, 2024
      </p>
      <hr>
      <p>
        This Privacy Policy (“Policy”) describes the manner in which InFinity Pool Solutions LLC  (“Defi Pool”, “we,” or “us”) and our website (the “Site”) use and collect data from individuals. This Policy, which is incorporated into and is subject to the Defi Pool Terms of Use, describes the information that we gather from you on the Site, how we use and disclose such information, and the steps we take to protect such information.
      </p>
      <h2>
        Information We Collect on the Site:
      </h2>
      <p>
        User-provided Information. When you use the Site, we may collect information about you, including your name, email address, mailing address, credit card or other billing information. You may provide us with information in various ways on the Site. For example, you provide us with information when you make a purchase on the Site, or send us customer service-related requests.
      </p>
      <p>
        Cookies and Automatically Collected Information. When you use the Site, we may send one or more cookies – small text files containing a string of alphanumeric characters – to your device. We may use both session cookies and persistent cookies. A session cookie disappears after you close your browser. A persistent cookie remains after you close your browser and may be used by your browser on subsequent visits to the Site. Please review your web browser “Help” file to learn the proper way to modify your cookie settings.
      </p>
      <h2>
        How We Use the Information We Collect
      </h2>
      <p>
        We use information we collect on the Site in a variety of ways in providing the Site and operating our business, including the following:
      </p>
      <ul>
        <li>
          We use the information that we collect on the Site to operate, maintain, enhance and provide all features of the Site, to provide services and information that you request, to respond to comments and questions and otherwise to provide support to users, and to process and deliver entries and rewards in connection with promotions that may be offered from time to time on the Site.
        </li>
        <li>
          We use the information that we collect on the Site to understand and analyze the usage trends and preferences of our users, to improve the Site, and to develop new products, services, features, and functionality.
        </li>
        <li>
          We may use your email address or other information we collect to contact you for administrative purposes such as customer service or to send communications, including updates on promotions and events, relating to products and services offered by us and by third parties.
        </li>
        <li>
          We may use cookies and automatically collected information to: (i) personalize our Site, such as remembering information about you so that you will not have to re-enter it during your visit or the next time you visit the Site; (ii) provide customized advertisements, content, and information; (iii) monitor and analyze the effectiveness of the Site and third-party marketing activities; (iv) monitor aggregate site usage metrics such as total number of visitors and pages viewed; and (v) track your entries, submissions, and status in any promotions or other activities on the Site.
        </li>
      </ul>
      <h2>
        When We Disclose Information
      </h2>
      <p>
        Except as described in this Policy, we will not disclose information about you that we collect on the Site to third parties without your consent. We may disclose information to third parties if you consent to us doing so, as well as in the following circumstances:
      </p>
      <ul>
        <li>
          Any information that you voluntarily choose to include in a publicly accessible area of the Site will be available to anyone who has access to that content, including other users.
        </li>
        <li>
          We work with third party service providers to provide website, application development, hosting, maintenance, printing, and other services for us. These third parties may have access to or process information about you as part of providing those services for us.
        </li>
        <li>
          We may disclose information about you if required to do so by law or in the good-faith belief that such action is necessary to comply with state and federal laws, in response to a court order, judicial or other government subpoena or warrant, or to otherwise cooperate with law enforcement or other governmental agencies.
        </li>
        <li>
          We also reserve the right to disclose information about you that we believe, in good faith, is appropriate or necessary to: (i) take precautions against liability; (ii) protect ourselves or others from fraudulent, abusive, or unlawful uses or activity; (iii) investigate and defend ourselves against any third-party claims or allegations; (iv) protect the security or integrity of the Site and any facilities or equipment used to make the Site available; or (v) protect our property or other legal rights (including, but not limited to, enforcement of our agreements), or the rights, property, or safety of others.
        </li>
        <li>
          Information about our users may be disclosed and otherwise transferred to an acquirer, successor, or assignee as part of any merger, acquisition, debt financing, sale of assets, or similar transaction, or in the event of an insolvency, bankruptcy, or receivership in which information is transferred to one or more third parties as one of our business assets.
        </li>
        <li>
          We may make certain aggregated, automatically-collected, or otherwise non-personal information available to third parties for various purposes, including: (i) compliance with various reporting obligations; (ii) for business or marketing purposes; or (iii) to assist such parties in understanding our users’ interests, habits, and usage patterns for certain programs, content, services, advertisements, promotions, and/or functionality available through the Site.
        </li>
      </ul>
      <h2>
        Your Choices
      </h2>
      <p>
        You may, of course, decline to share certain information with us, in which case we may not be able to provide to you some of the features and functionality of the Site. You may update, correct, or delete your account information and preferences at any time by accessing your account preferences page on the Site. If you wish to access or amend any other personal information we hold about you, you may contact us at. Please note that while any changes you make will be reflected in active user databases within a reasonable period of time, we may retain all information you submit for backups, archiving, prevention of fraud and abuse, analytics, satisfaction of legal obligations, or where we otherwise reasonably believe that we have a legitimate reason to do so.
      </p>
      <p>
        If you receive commercial email from us, you may unsubscribe at any time by following the instructions contained within the email. You may also opt out from receiving commercial email from us by sending your request to us by email ator by writing to us at the address given at the end of this policy. We may allow you to view and modify settings relating to the nature and frequency of promotional communications that you receive from us in user account functionality on the Site.
      </p>
      <p>
        Please be aware that if you opt out of receiving commercial email from us or otherwise modify the nature or frequency of promotional communications you receive from us, it may take up to ten business days for us to process your request, and you may continue receiving promotional communications from us during that period. Additionally, even after you opt out from receiving commercial messages from us, you will continue to receive administrative messages from us regarding the Site.
      </p>
      <h2>
        Third-Party Sites
      </h2>
      <p>
        The Site may contain features or links to websites and services provided by third parties. Any information you provide on third-party sites or services is provided directly to the operators of such services and is subject to those operators’ policies, if any, governing privacy and security, even if accessed through the Site. We are not responsible for the content or privacy and security practices and policies of third-party sites or services to which links or access are provided through the Site. We encourage you to learn about third parties’ privacy and security policies before providing them with information.
      </p>
      <h2>
        Children’s Privacy
      </h2>
      <p>
        Protecting the privacy of young children is especially important. Our Site is a general audience site not directed to children under the age of 13, and we do not knowingly collect personal information from children under the age of 13 without obtaining parental consent.
      </p>
      <h2>
        Data Security
      </h2>
      <p>
        We use certain physical, managerial, and technical safeguards that are designed to improve the integrity and security of information that we collect and maintain. Please be aware that no security measures are perfect or impenetrable. We cannot and do not guarantee that information about you will not be accessed, viewed, disclosed, altered, or destroyed by breach of any of our physical, technical, or managerial safeguards.
      </p>
      <h2>
        Changes and Updates to this Policy
      </h2>
      <p>
        Please revisit this page periodically to stay aware of any changes to this Policy, which we may update from time to time. If we modify this Policy, we will make it available through the Site, and indicate the date of the latest revision. In the event that the modifications materially alter your rights or obligations hereunder, we will make reasonable efforts to notify you of the change. For example, we may send a message to your email address, if we have one on file, or generate a pop-up or similar notification when you access the Site for the first time after such material changes are made. Your continued use of the Site after the revised Policy has become effective indicates that you have read, understood and agreed to the current version of this Policy.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PolicyPage',
  layout: 'new',
  async fetch({ store, error, route }) {
    try {
      const pageName = route.name.split('___')
      const seoData = store.getters['seos/seosByUri'](pageName[0])
      if (seoData === null) {
        await store.dispatch('seos/fetchSeos', {
          uri: route.name
        })
      }
    } catch (err) {
      error(err)
    }
  },
  head({ $config: { appUrl } }) {
    return {
      title: this.meta ? this.meta.title : this.$t('common.launching'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-description',
          name: 'og:description',
          content: this.meta ? this.meta.description : ''
        },
        {
          hid: 'og-title',
          name: 'og:title',
          content: this.meta
            ? this.meta.title
            : this.$t('common.launching')
        },
        {
          hid: 'og-image',
          name: 'og:image',
          content: this.meta
            ? this.meta.image
            : appUrl + 'seo/default.jpg'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.meta ? this.meta.keyword : ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters('seos', [
      'seosByUri'
    ]),
    meta() {
      const pageName = this.$nuxt.$route.name.split('___')
      return this.seosByUri(pageName[0])
    }
  }
}
</script>

<style scoped>
  @import url('../assets/css/new/doc.css');
</style>
